import React from 'react';
import Subscriptions from './Subscriptions';
import AdminUsersCard from './AdminUsersCard';
import DocumentTitle from 'react-document-title'

class AdminDashboardPage extends React.Component {
    constructor(props, context) {
        super(props, context);
    }

    render() {
        return (
            <div>
                <DocumentTitle title="Admin Dashboard" />
                <div className="dashboard-wrapper container-fluid p-4">
                    <main role="main">
                        <Subscriptions />
                        <br />
                        <AdminUsersCard />
                    </main>
                </div>
            </div>
        );
    }
}

export default AdminDashboardPage;
